import { toast } from "sonner";
import WithdrawAddresses from "src/components/withdraw-addresses/withdraw-addresses";

export function AddressesList() {
	const openNotification = (title: string, description: string) => {
		toast.success(title, {
			description,
		});
	};

	return <WithdrawAddresses openPopupFunc={openNotification} />;
}
